<script>
export default {
    name: "ViewImage",

    props: {
        image: Object,
        showModal: Boolean,
    },
}
</script>
<template>
<tail-modal :show="showModal" dimension="w-11/12 h-auto">
  <template v-slot:title>
    <h5 class="label-control">Radiology image</h5>
  </template>
  <template v-slot:modal-body>
    <div class="w-full flex flex-wrap -m-4">
        <iframe :src="`data:application/pdf;base64,${image.investigationImage}`" height="700" width="2000"></iframe>
    </div>
  </template>
  <template v-slot:modal-footer>
    <button 
      class="btn-danger btn-sm text-xs rounded" 
      @click="$emit(`closeModal`)">
        <i class="fa fa-times"></i> Cancel</button>
  </template>
</tail-modal>
</template>